import { Component, PropsWithChildren } from 'react';
import { ApiClient } from '@dozuki/web-js/utils';
import { ErrorPage, Layout } from '~/page-components/Layout';
import { NextRouter, withRouter } from 'next/router';
import { isBffError, isUnauthenticatedError } from '~/framework/bff';

interface ErrorState {
   error: Error | null;
}

type ErrorBoundaryProps = PropsWithChildren<{ router: NextRouter }>;

class ErrorBoundaryComponent extends Component<ErrorBoundaryProps, ErrorState> {
   public state: ErrorState = {
      error: null,
   };

   componentDidCatch(error: Error) {
      if (isUnauthenticatedError(error)) {
         this.props.router.push('/Login');
         return;
      }

      this.setState({
         error,
      });
   }

   getStatusCodeFromError(error: Error) {
      if (!ApiClient.isApiError(error) || !isBffError(error)) {
         return 500;
      }

      return error.response?.status || 500;
   }

   render() {
      const { error } = this.state;
      const statusCode = error && this.getStatusCodeFromError(error);

      return statusCode ? (
         <Layout>
            <ErrorPage error={{ code: statusCode }} />
         </Layout>
      ) : (
         this.props.children
      );
   }
}

export const ErrorBoundary = withRouter(ErrorBoundaryComponent);
